import vsComponent from './vsPopup'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
